/* created by CoolGuy on 2018/12/9 */
import React from 'react';
import { debounce } from '../../utils/util';
import { inject, observer } from 'mobx-react';
import intl from 'react-intl-universal';

@inject('rootStore')
@observer
class MultiFuncBottomArea extends React.Component {
  toSendRedPack = debounce(() => {
    this.props.rootStore.redPackStore.setSendModal(true);
  });
  render() {
    return (
      <div className="multi-func-bottom-area">
        <div className="icons8" onClick={this.toSendRedPack}>
          <i className="red-pack" />
          <span className="name">{intl.get('Red Packet')}</span>
        </div>
        <div className="icons8" />
        <div className="icons8" />
        <div className="icons8" />
        <div className="icons8" />
        <div className="icons8" />
        <div className="icons8" />
        <div className="icons8" />
      </div>
    );
  }
}

export default MultiFuncBottomArea;
